"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumComponentConnectionNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const AltiumNetNamingRule_1 = require("./AltiumNetNamingRule");
const project_1 = require("../../project");
const compareAltiumPinReferences_1 = require("./compareAltiumPinReferences");
class AltiumComponentConnectionNamingRule extends AltiumNetNamingRule_1.AltiumNetNamingRule {
    apply(group, _hierarchy) {
        const hierarchicalNaming = this.config.higherLevelNamesTakePriority === project_1.NameNetsHierarchicallyMode.Yes;
        const connections = [];
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            for (const net of nets) {
                for (const conn of net.connections) {
                    connections.push({
                        moduleName: conn.connection.moduleName,
                        pinRef: conn.connection.pinRef,
                        depth,
                    });
                }
            }
        }
        if (connections.length === 0) {
            return undefined;
        }
        connections.sort((a, b) => {
            if (hierarchicalNaming && a.depth !== b.depth) {
                return a.depth - b.depth;
            }
            const moduleCompare = sigma_engine_shared_1.Utils.naturalStringSort(a.moduleName, b.moduleName);
            if (moduleCompare !== 0) {
                return moduleCompare;
            }
            return (0, compareAltiumPinReferences_1.compareAltiumPinReferences)(a.pinRef, b.pinRef);
        });
        const firstConn = connections[0];
        return `Net${firstConn.moduleName}_${firstConn.pinRef}`;
    }
}
exports.AltiumComponentConnectionNamingRule = AltiumComponentConnectionNamingRule;
//# sourceMappingURL=AltiumComponentConnectionNamingRule.js.map